import React from 'react'

import './styles.scss'

const AppLoader: React.FC = () => {
  return (
    <div className="app-loader">
      <div className="app-loader__loader">
        <div className="app-loader__spinner">
          <div className="app-loader__css-loader"></div>
        </div>
        <div className="app-loader__logo"></div>
      </div>
    </div>
  )
}

export default AppLoader
